import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import YouTube from 'react-youtube';

import { rtcBufferActions, jukeboxActions } from '../../redux/actions/';
import { Container, Listing, ButtonRow, Button, AudioItems, Item, AudioName, AudioPlay, AudioEdit, Player, Label, Input, Slider, NoMusic } from './Jukebox.styles';
import T from '../i18n/i18n';
import { editJukebox, addJukebox, listJukebox, removeJukebox} from '../../services/jukebox';

const videoConfig = (videoId) => ({
    height: '203',
    width: '360',
    disablekb: 1,
    controls: 0,
    fs: 0,
    playerVars: {
        //playlist: videoId,
        iv_load_policy: 3,
        loop: 1,
        autoplay: 1
    }
});

export default ({tableId}) => {

    const [volume, setVolume] = useState(10);
    const [formId, setFormId] = useState(null);
    const [formName, setFormName] = useState('');
    const [formYoutube, setFormYoutube] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [audiolist, setAudiolist] = useState([]);

    const isOwner = useSelector(state => state.authState.isOwner);
    const playing = useSelector(state => state.jukeboxState.playing);
    const videoApi = useRef(null);

    useEffect(() => {
        (async () => {
            if (!isOwner || !tableId) {
                return;
            }
            let req = await listJukebox(tableId);
            if (req.status === 'ok') {
                setAudiolist(req.payload);
            }
        })();
    },[tableId, isOwner]);

    useEffect(() => {
        if (!playing) {
            videoApi.current = null;
        }
    }, [playing]);


    const dispatch = useDispatch();

    const openForm = () => {
        setShowForm(true);
    }

    const validForm = () => {
        let name = formName;
        let linkReg = formYoutube.match(/\?v=(.*?)(&|$)/);
        let link = linkReg ? (linkReg[1] || null) : null;

        return link && name;
    }

    const saveForm = async () => {
        if (!validForm()) {
            return;
        }

        setShowForm(false);

        let id = formId;
        let name = formName;
        let linkReg = formYoutube.match(/\?v=(.*?)(&|$)/);
        let link = linkReg ? (linkReg[1] || null) : null;
        let req = null;

        if (id) {
            req = await editJukebox(tableId, id, name, link);
        } else {
            req = await addJukebox(tableId, name, link);
        }

        if (req.status === 'ok') {
            setFormId(null);
            setFormName('');
            setFormYoutube('');
            setAudiolist(req.payload);
        } else {
            console.error(Object.assign({},{component:'Jukebox', id: 'saveForm'}));
        }
    }

    const cancelForm = () => {
        setShowForm(false);
        setFormId(null);
        setFormName('');
        setFormYoutube('');
    }

    const editForm = (item) => {
        setShowForm(true);
        setFormId(item.id);
        setFormName(item.name);
        setFormYoutube(`https://www.youtube.com/watch?v=${item.value}`);
    }

    const removeItem = async () => {
        let req = await removeJukebox(tableId, formId);
        if (req.status === 'ok') {
            setShowForm(false);
            setFormId(null);
            setFormName('');
            setFormYoutube('');
            setAudiolist(req.payload);
        }
    }

    const startPlayFromYoutube = (id) => {
        dispatch(rtcBufferActions.pushOutputBuffer({
            type: 'jukeboxPlayYT',
            data: {
                videoId: id
            }
        }));

        dispatch(jukeboxActions.startPlay(id));
    }

    const stopPlayFromYoutube = () => {
        dispatch(rtcBufferActions.pushOutputBuffer({
            type: 'jukeboxStopYT',
            data: {
                videoId: ''
            }
        }));

        dispatch(jukeboxActions.stopPlay(''));
    }

    const setPlayerVolume = (vol) => {
        setVolume(vol);
        if (videoApi.current) {
            videoApi.current.setVolume(vol*0.5);
        }
    }

    return <Container>
        <Listing className={'scrollbar'}>
            {isOwner && <>
                {showForm ? <>
                    <Label><T value="jukebox.name" /></Label>
                    <Input value={formName} onChange={(e)=>{setFormName(e.target.value)}} />
                    <Label><T value="jukebox.youtube" /></Label>
                    <Input value={formYoutube} onChange={(e)=>{setFormYoutube(e.target.value)}} />
                    <ButtonRow>
                        <Button color={formId ? "#26f" : "#0c0"} className={!validForm() ? 'disabled' : ''} onClick={saveForm}><T value={formId ? "edit" : "add"} /></Button>
                        {formId ? <Button color="#fa0" onClick={removeItem}><T value="delete" /></Button> : null }
                        <Button color="#f44" onClick={cancelForm}><T value="cancel" /></Button>
                    </ButtonRow>
                </> : <>
                    <AudioItems>
                        {!audiolist || audiolist.length < 1 ? <NoMusic>
                            <T value="jukebox.noMusic" />
                        </NoMusic> : audiolist.map((item, i) => <Item key={i}>
                            {playing === item.value ? 
                                <AudioPlay className="stop" onClick={()=>{stopPlayFromYoutube()}}/>
                            :
                                <AudioPlay onClick={()=>{startPlayFromYoutube(item.value)}}/>
                            }
                            <AudioName>{item.name}</AudioName>
                            <AudioEdit onClick={()=>{editForm(item)}} />
                        </Item>)}
                    </AudioItems>
                    <ButtonRow>
                        <Button color="#0c0" onClick={openForm}><T value="jukebox.add" /></Button>
                    </ButtonRow>
                </>}
            </>}
        </Listing>

        <Player className={playing ? 'full' : 'compact'}>
            <Label><T value="jukebox.volume" /></Label>
            <Slider type="range" min="1" max="100" value={volume} onChange={(e) => {setPlayerVolume(e.target.value)}} />
            <Label><T value="jukebox.player" /></Label>
            {playing ? <YouTube 
                videoId={playing} 
                opts={videoConfig(playing)} 
                onReady={(e)=>{
                    videoApi.current = e.target;
                    e.target.setVolume(volume*0.5);
                    e.target.playVideo();
                }}
                onEnd={()=>{
                    videoApi.current.playVideo();
                }}
            /> : null}
        </Player>
    </Container>
};